import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, ResponsiveContainer, AreaChart, Area, ReferenceArea, ComposedChart, Line} from "recharts"
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";
import { deleteUser, getSwitchInfo, getEmergencyLogs, deleteEmergencyLog, getPowerTimeline } from "../../services/userApiServicer";

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}; 
const ONE_HOUR = 60 * 60 * 1000;
const today = new Date();
const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(today.getDate() - 6);

export default function UserDetail() {
  const navigate = useNavigate();
    const location = useLocation();
    const [tab, setTab] = useState("info");
    useEffect(() => {
    if (location.state?.defaultTab) {
        setTab(location.state.defaultTab);
    }
    }, [location.state]);
  const token = localStorage.getItem("token");
  const user = token ? parseJwt(token) : null;
  const [userData, setUserData] = useState({});
  const [dailySwitchCount, setDailySwitchCount] = useState([]);
  const [dailySwitchonline, setDailySwitchonline] = useState([]);
  const [dailySwitchTimeline, setDailySwitchTimeline] = useState([]);
  const [powerData, setPowerData] = useState([]);
  const [emergencyLogs, setEmergencyLogs] = useState([]);
  const { id } = useParams();
  const isSuperAdmin = user?.auth === 1;

  const fetchUserList = async () => {
    try {
      console.log('userData.id : ', user.id)
      console.log("token : ", token)
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
      console.log("사용자 목록 불러오기 성공:", response.data.user);
      setUserData(response.data.user);
    } catch (error) {
      console.error("사용자 목록 불러오기 실패:", error);
    }
  };
  const handleTabChange = (newTab) => {
    setTab(newTab);
    localStorage.setItem("selectedTab", newTab);
  };
  const formatDateToMMDD = (isoDate) => {
    const date = new Date(isoDate);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}/${day}`;
  };
  const formatMinutesToHours = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    if (h > 0) {
      return `${h}시간 ${m}분`;
    } else {
      return `${m}분`;
    }
  };
  const getRoundedMax = (data, key, unit = 10) => {
    const maxValue = Math.max(...data.map((item) => item[key] || 0));
    return Math.ceil(maxValue / unit) * unit + 10;
  };
  const SwitchInfo = async () => {
    try {

      const data = await getSwitchInfo(userData.id, token);
      if (data.success === false) {
        alert(data.message);
        return;
      }
      console.log("사용자 스위치 정보", userData.id)
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      const formattedSwitchCount = data.switch_count.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));

      const formattedSwitchTimeline = data.switch_start_end.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));
      const formattedSwitchOnline = data.switch_on.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));

      setDailySwitchCount(formattedSwitchCount);
      setDailySwitchonline(formattedSwitchOnline);
      setDailySwitchTimeline(formattedSwitchTimeline);
      console.log("스위치 정보 ", data)

    } catch (error) {
      console.error("스위치 전력 정보", error);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  useEffect(() => {
    if (userData?.id) {
      SwitchInfo();
      fetchEmergencyLogs();
      fetchPowerData();
    }
  }, [userData]);

  useEffect(() => {
  // 1시간(60분 * 60초 * 1000밀리초)
  const intervalId = setInterval(() => {
    if (userData?.id) {
      fetchPowerData();
      SwitchInfo();
      fetchEmergencyLogs();
    }
  }, 60 * 60 * 1000);

  // 컴포넌트 언마운트 시 interval 정리
  return () => clearInterval(intervalId);
}, [userData]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDelete = async () => {
    console.log("delete", userData.id);
    if (!window.confirm(`정말 ${userData.name}님을 삭제하시겠습니까?`)) return;

    try {
      const result = await deleteUser(userData.id, token);
      if (result.success === false) {
        alert(result.message);
        return;
      }
      alert(result.message);
      navigate("/user");
    } catch (error) {
      console.error("삭제 실패:", error);
      alert("사용자 삭제에 실패했습니다.");
    }
  };


const fetchEmergencyLogs = async () => {
  try {
    const data = await getEmergencyLogs(userData.id, token);
    setEmergencyLogs(data || []);
    console.log("응급상황 데이터:", data);
  } catch (error) {
    alert("응급상황 기록을 불러오지 못했습니다.");
  }
};

const handleDeleteLog = async (alert_id) => {
  if (!window.confirm("정말 이 응급상황 기록을 삭제하시겠습니까?")) return;

  try {
    const result = await deleteEmergencyLog(alert_id, token);
    if (result.success === false) {
      alert(result.message);
      return;
    }
    alert("삭제가 완료되었습니다.");
    fetchEmergencyLogs(); // 삭제 후 새로고침
  } catch (error) {
    alert("삭제 중 오류가 발생했습니다.");
  }
};

/* 전력 */
const fetchPowerData = async () => {
  try {
    const raw = await getPowerTimeline(userData.id, token);
    if (!Array.isArray(raw) || raw.length === 0) {

	const emptyDayData = [];
	const baseDate = moment().startOf('day');

	for (let minute = 0; minute < 24 * 60; minute++) {
  		const currentTime = baseDate.clone().add(minute, 'minutes');

    		emptyDayData.push({
      			time: currentTime.format("HH:mm"),
      			watt: null,
      			state: "unknown"
    		});
  	}

  	setPowerData(emptyDayData);

	return;
    }
    // 시간별로 정렬
    const sorted = [...raw].sort((a, b) => 
      moment(a.create_date).diff(moment(b.create_date))
    );

    // 00:00 ~ 23:59까지 1분 단위로 전체 타임라인 생성
    const fullDayData = [];
    const baseDate = moment(sorted[0].create_date).startOf('day');
    const firstDataTime = moment(sorted[0].create_date);
    const now = moment(); // 현재 시간
    const lastDataTime = moment(sorted[sorted.length - 1].create_date);
    
    for (let minute = 0; minute < 24 * 60; minute++) {
      const currentTime = baseDate.clone().add(minute, 'minutes');
      const timeStr = currentTime.format("HH:mm");
      
      // 첫 데이터 시간 이전이면 꺼진 상태(0W)로 표시
      if (currentTime.isBefore(firstDataTime)) {
        fullDayData.push({
          time: timeStr,
          watt: 0,
          state: "off"
        });
        continue;
      }
      
      // 마지막 데이터 이후이고 현재 시간을 넘어가면 null로 표시 (색 칠하지 않음)
      if (currentTime.isAfter(lastDataTime) && currentTime.isAfter(now)) {
        fullDayData.push({
          time: timeStr,
          watt: null,
          state: "unknown"
        });
        continue;
      }
      
      // 해당 시간의 전력 상태 찾기 (가장 최근의 상태를 찾음)
      let watt = null;
      let state = "off";
      
      for (let i = sorted.length - 1; i >= 0; i--) {
        const dataTime = moment(sorted[i].create_date);
        if (dataTime.isSameOrBefore(currentTime)) {
          watt = sorted[i].watt;
          state = watt > 0 ? "on" : "off";
          break;
        }
      }
      
      fullDayData.push({
        time: timeStr,
        watt: watt,
        state: state
      });
    }
    console.log(
  '[POWER DEBUG]',
  {
    rawLength: raw.length,
    sortedFirst: sorted[0],
    sortedLast: sorted[sorted.length - 1],
    fullLength: fullDayData.length,
    nonZero: fullDayData
      .filter(x => Number(x.watt) > 0)
      .slice(0, 20)
  }
);
    setPowerData(fullDayData);
  } catch (err) {
    console.error("전력 데이터 처리 실패", err);
  }
};

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="user">
        <h1>사용자 관리</h1>
        <div className="user_box">
          <div className="tabs_wrp">
            <button onClick={() => handleTabChange("info")} className={tab === "info" ? "active" : ""}>사용자</button>
            <button onClick={() => handleTabChange("power")} className={tab === "power" ? "active" : ""}>스위치</button>            
            <button onClick={() => handleTabChange("energy")} className={tab === "energy" ? "active" : ""}>전력</button>
            <button onClick={() => handleTabChange("alert")} className={tab === "alert" ? "active" : ""}>응급상황</button>
          </div>
          {/* 사용자 상세정보 */}
          {tab === "info" && (
            <div className="user_detail">
              <h2 className="subpage_title"><span className="before"><span className="nametit">{userData.name}</span> 님의 상세정보</span></h2>
              <div className="detail_box">
                <ul>
                  <li>
                    <p className="tit">나이</p>
                    <p className="txt">
                      {userData.age != null ? `만 ${userData.age}세` : "-"}
                    </p>
                  </li>
                  <li>
                    <p className="tit">생년월일</p>
                    <p className="txt">{userData.birth?.trim() ? userData.birth : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">성별</p>
                    <p className="txt">{userData.sex?.trim() ? userData.sex : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">전화번호</p>
                    <p className="txt">{userData.phone?.trim() ? userData.phone : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">주소</p>
                    <p className="txt">
                      {(userData.address?.trim() ? userData.address : "-")}{" "}
                      {(userData.detail_address?.trim())}
                    </p>
                  </li>
                  <li>
                    <p className="tit">담당 관리</p>
                    <p className="txt">{userData.department_name?.trim() ? userData.department_name : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">가족정보</p>
                    <p className="txt">
                      {Array.isArray(userData.family) && userData.family.length > 0 ? (
                        userData.family.map((member, index) => (
                          <span key={index} className="family">
                            {member.family_info?.trim() ? member.family_info : "-"}
                          </span>
                        ))
                      ) : (
                        "등록된 가족정보가 없습니다."
                      )}
                    </p>
                  </li>
                  <li>
                    <p className="tit">지병</p>
                    <p className="txt">{userData.pec?.trim() ? userData.pec : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">위험군 등급</p>
                    <p className="txt">{userData.sev_name?.trim() ? userData.sev_name : "-"}</p>
                  </li>
                  <li>
                    <p className="tit">응급상황 횟수</p>
                    <p className="txt">
                      {userData.alert_count != null ? `${userData.alert_count}회` : "-"}
                    </p>
                  </li>
                </ul>

              </div>
              <div className="btn-group">
                {isSuperAdmin && (<button className="btncolor02" onClick={handleDelete}>삭제</button>)}
                {isSuperAdmin && (<button className="btncolor04" onClick={() => navigate("/user/edit", { state: { userData } })}>수정</button>)}
                <button className="btncolor01" onClick={() => navigate("/user")}>확인</button>
              </div>
            </div>
          )}

          {/* 사용자 스위치 */}
          {tab === "power" && (
            <div className="user_power">
              <h2 className="subpage_title"><span className="before"><span className="nametit">{userData.name}</span> 님의 상세정보</span></h2>
              <div className="power_charts_wrp">
                <div className="chart01">
                  <div className="chartbox">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={dailySwitchCount} margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
                        <XAxis dataKey="event_date" tick={{ fontSize: 11 }}/>
                        <YAxis
                          width={60}
                          tickFormatter={(value) => `${value}회`}
                          domain={[0, 'dataMax + 2']}
                        />
                        <Tooltip formatter={(val) => [`${val}회`, '스위치 횟수']} />

                        <Bar dataKey="event_count" fill="#4f9df9" barSize={40}>
                          <LabelList dataKey="event_count" position="top" formatter={(val) => `${val}회`} />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <p className="chartit">일별 스위치 사용 횟수</p>
                </div>
                <div className="chart02">
                  <div className="chartbox">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={dailySwitchonline} margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
                        <XAxis dataKey="event_date" tick={{ fontSize: 11 }}/>
                        <YAxis
                          width={60}
                          tickFormatter={(value) => `${value}분`}
                          domain={[0, getRoundedMax(dailySwitchonline, 'on_minutes', 10)]}
                        />
                        <Tooltip formatter={(val) => [formatMinutesToHours(val), `스위치 지속시간`]} />
                        <Bar dataKey="on_minutes" fill="#ff914d" barSize={40}>
                          <LabelList dataKey="on_minutes" position="top" formatter={formatMinutesToHours} />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>

                  </div>
                  <p className="chartit">일별 스위치 ON 지속 시간</p>
                </div>
              </div>
              <div className="table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      {dailySwitchTimeline.map((item) => (
                        <th key={item.event_date}>{item.event_date}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>첫 방문 시간</td>
                      {dailySwitchTimeline.map((item, i) => (
                        <td key={i}>{item.first_on_time}</td>
                      ))}
                    </tr>
                    <tr>
                      <td>마지막 방문 시간</td>
                      {dailySwitchTimeline.map((item, i) => (
                        <td key={i}>{item.last_on_time}</td>
                      ))}
                    </tr>
                    <tr>
                      <td>수면 추정 시간</td>
                      {dailySwitchTimeline.map((item, i) => (
                        <td key={i}>{item.sleep_start_end_time}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="btn-group">
                <button className="btncolor01" onClick={handleGoBack}>확인</button>
              </div>
            </div>
          )}
          {/* 사용자 전력량 */}
         {tab === "energy" && (
  <div className="user_power">
    <h2 className="subpage_title">
      <span className="before">
        <span className="nametit">{userData.name}</span> 님의 전력정보
      </span>
    </h2>
    <div className="power_charts_wrp">
      <div className="chart01">
        <div className="chartbox">
            <ResponsiveContainer width="100%" height={380}>
                <ComposedChart
                    data={powerData}
                    margin={{ top: 40, right: 20, left: 20, bottom: 20 }}
                >
                <XAxis 
                dataKey="time"
                interval={119}
                tick={{ fontSize: 12 }}
                />
                <YAxis width={60} domain={[0, 10]} />
                <Tooltip
                formatter={(v) => (v !== null ? `${v}W` : "데이터 없음")}
                labelFormatter={(label) => `시간: ${label}`}
                />

                <Area
                type="monotone"
                dataKey="watt"
                stroke="none"
                fill="#ff5722"
                fillOpacity={0.3}
                tooltipType="none"
                dot={false}
                isAnimationActive={false}
                label={({ x, y, index }) => {
                    // 마지막 watt 값이 있는 지점 찾기
                    const lastWattIndex = powerData.map((d, i) => d.watt !== null ? i : -1)
                    .filter(i => i !== -1)
                    .pop();
                    
                    // 마지막 watt 지점이고, 그 이후에 null이 있으면 현재시간 표시
                    if (index === lastWattIndex && powerData.slice(lastWattIndex + 1).some(d => d.watt === null)) {
                    return (
                        <text x={x} y={y - 10} fill="#ff5722" fontSize={12} fontWeight="bold" textAnchor="middle">
                        현재 시간: {moment().format("HH:mm")}
                        </text>
                    );
                    }
                    return null;
                    }}
                    />

                    {/* 선 그래프 */}
                    <Line
                    type="monotone"
                    dataKey="watt"
                    stroke="#ff5722"
                    strokeWidth={2}
                    dot={false}
                    isAnimationActive={false}
                    />

                </ComposedChart>
            </ResponsiveContainer>



        </div>
        <p className="chartit">켜짐/꺼짐 구간 전력 변화</p>
      </div>
    </div>
    <div className="btn-group">
      <button className="btncolor01" onClick={handleGoBack}>확인</button>
    </div>
  </div>
)}

          {/* 사용자 응급상황기록 */}
          {tab === "alert" && (
            <div className="user_detail">
              <h2 className="subpage_title"><span className="before"><span className="nametit">{userData.name}</span> 님의 상세정보</span></h2>
              <div className="detail_box">
                <ul>
                  <li className="noflex"><p className="tit">응급상황 기록</p></li>
                </ul>
                {emergencyLogs.length > 0 ? (
                  emergencyLogs.map((log, index) => (
                    <div key={index} className="emergency_log">
                      <p className="emergency_title_line">{moment(log.create_date).format("YYYY-MM-DD")} 발생한 응급상황 </p>
                      <p className="write_info">작성자 : {log.admin_name}<span>작성시간 : {log.write_create_date}</span></p>
                      <p className="emergency_log_tit">증상 및 상황조치</p>                      
                      <p className="emergency_log_txt">{log.content}</p>                      
                      <div className="btn-group">
                        <button className="btncolor02" onClick={() => handleDeleteLog(log.alert_id)}>삭제</button>
                        <button className="btncolor04" onClick={() => navigate("/user/alert/edit", { state: { log, adminId: user?.id } })}>수정</button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>등록된 응급상황 기록이 없습니다.</p>
                )}
              </div>
              <div className="btn-group">
                <button className="btncolor02" onClick={() => navigate("/user/alert/new", { state: { user_id: userData.id, admin_id: user?.id } })
                } >등록</button>
                <button className="btncolor01" onClick={handleGoBack}>확인</button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
